import Routes from '../../../routes';

var CryptPay = {};

CryptPay.initialize = function () {
  $('#cryptpay_form').submit(function (event) {
    if (Payment.verifyRequired('#cryptpay_form') && Payment.verifyCC($('#cryptpay_form'))) {
      $('#cryptpay_form .btn').buttonState('loading');
      return true;
    }
    else {
      $('#cryptpay_form .btn').buttonState('reset');
    }
    event.stopImmediatePropagation();
    return false;
  });

  $('#cryptpay_form').submit(function (event, cryptpay_fields_populated) {
    if (cryptpay_fields_populated) {
      return true;
    }
    $.ajax({url: Routes.cryptpay_timestamp_and_hash_path(),
      success: function (data) {
        $('#cryptpayHash').val(data.hash);
        $('#cryptpayTimestamp').val(data.timestamp);
        $('#cryptpay_form').trigger('submit', true);
        return true;
      },
      error: function () {
        alert('An unexpected error has occurred. Please try again and contact support if the problem persists.');
        $('#cryptpayHash').val(null);
        $('#cryptpayTimestamp').val(null);
        $('#cryptpay_form .btn').buttonState('reset');
      }
    });
    return false;
  });
};

global.CryptPay = global.CryptPay || CryptPay;
